var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('textarea',{staticClass:"form-control border w-100",attrs:{"id":_vm.id_computed,"required":_vm.required,"placeholder":_vm.placeholder},on:{"input":_vm.updateValue}},[_vm._v(_vm._s(_vm.request_form[_vm.id_computed] ?? ''))])])
}
var staticRenderFns = []

export { render, staticRenderFns }